import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import IconStar from '../icons/star.svg'
import IconUser from '../icons/user.svg'
import kebabCase from '../utils/kebabCase'

const BlogIndex = ({ data }) => (
	<>
		{data.allMarkdownRemark.edges.map(({ node }) => (
			<article
				className={`post-wrap visible animate fade-in d-flex ${
					node.frontmatter.thumbnail !== `` ? `` : `no-image`
				}`}
				key={node.fields.slug}
			>
				{node.frontmatter.thumbnail && (
					<Link
						to={node.fields.slug}
						className="featured-image-wrap"
						aria-label="Featured image"
					>
						<div
							className="featured-image"
							style={{
								backgroundImage: `url(${node.frontmatter.thumbnail.childImageSharp.fluid.src})`,
							}}
						/>
					</Link>
				)}
				<div className="post-info">
					{node.frontmatter.featured && (
						<span className="featured-label">
							<IconStar />
						</span>
					)}
					{node.frontmatter.tags && (
						<Link
							className="tag d-inline-flex"
							to={`/tags/${kebabCase(node.frontmatter.tags[0])}`}
						>
							{node.frontmatter.tags[0]}
						</Link>
					)}
					{/* temp category */}
					<span className="reading-time">{node.timeToRead} min read</span>
					<span className="date">{node.frontmatter.date}</span>
					<h2 className="title">
						<Link to={node.fields.slug}>{node.frontmatter.title}</Link>
					</h2>
					<div className="author d-flex flex-row align-items-center">
						<Link to={node.fields.slug}>
							{data.avatar ? (
								<Img
									fixed={data.avatar.childImageSharp.fixed}
									alt="avatar"
									className="avatar"
								/>
							) : (
								<div className="avatar no-image">
									<IconUser />
								</div>
							)}
						</Link>
						<div className="author-inner">
							<span className="name">
								<Link to={node.fields.slug}>{`Imed Adel`}</Link>
							</span>
						</div>
					</div>
				</div>
			</article>
		))}
	</>
)

const indexQuery = graphql`
	query {
		site {
			siteMetadata {
				title
				siteUrl
			}
		}
		avatar: file(absolutePath: { regex: "/profile-pic./" }) {
			childImageSharp {
				fixed(width: 40, height: 40) {
					...GatsbyImageSharpFixed
				}
			}
		}
		allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
			edges {
				node {
					excerpt
					fields {
						slug
					}
					timeToRead
					frontmatter {
						date(formatString: "MMMM DD, YYYY")
						title
						tags
						description
						featured
						thumbnail {
							childImageSharp {
								fluid(maxWidth: 1080) {
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
			}
		}
	}
`

export default props => (
	<StaticQuery
		query={indexQuery}
		render={data => (
			<BlogIndex location={props.location} data={data} {...props} />
		)}
	/>
)
